import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SharedAuthWrapperComponent } from '../components/shared-auth-wrapper/shared-auth-wrapper.component';
import { TestAuth0Component } from '../components/test-auth0/test-auth0.component';
import { TestAuth2Component } from '../components/test-auth2/test-auth2.component';



const routes: Routes = [

  {
    path: '',
    component: SharedAuthWrapperComponent,
    children: [
      {
        path: 'test-auth2',
        component: TestAuth2Component,
      },
      {
        path: 'test-auth0',
        component: TestAuth0Component,
      },

    ]
  },

];

@NgModule({
  //for child not for root since we are in a feature routing module
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule] //leave it there for future safety to avoid errors
})
export class SharedAuthRoutingModule { }
